import {
  SET_BOOKINGS,
} from '../types';

const initialState = {
  bookingList: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_BOOKINGS:
      return {
        ...state,
        bookingList: action.data,
      };
    default:
      return state;
  }
};
